import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { PageLoader } from "@/components/ui/page-loader";

/**
 * Auth callback route for local development.
 * The old app redirects here with ?token=xxx after login.
 * This sets the cookie and redirects to the intended connect page.
 *
 * Usage: localhost:3000/connect/auth-callback?token=USER_AUTH_TOKEN&next=/connect/teams
 */
export const Route = createFileRoute("/connect/auth-callback")({
	component: AuthCallback,
});

function AuthCallback() {
	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const token = params.get("token");
		const next = params.get("next") || "/connect";

		if (token) {
			// Set the cookie on this origin (7-day expiry)
			const expires = new Date();
			expires.setDate(expires.getDate() + 7);
			document.cookie = `user_auth_token=${token}; expires=${expires.toUTCString()}; path=/;`;

			// Redirect to the intended page
			window.location.href = next;
		} else {
			// No token — redirect to list page for login
			window.location.href = "/list";
		}
	}, []);

	return <PageLoader message="Setting up session..." />;
}
